import { render } from "./VerificationInfo.vue?vue&type=template&id=74fc27f3"
import script from "./VerificationInfo.vue?vue&type=script&lang=js"
export * from "./VerificationInfo.vue?vue&type=script&lang=js"

import "./VerificationInfo.vue?vue&type=style&index=0&id=74fc27f3&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__